module.exports = __webpack_public_path__ + "img/default-product.2fdf4d6.jpg";